var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogAddTask" }, [
    _c("div", { staticClass: "modal-card", staticStyle: { width: "620px" } }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            " " +
              _vm._s(_vm.isEdit ? "עריכת משימה בבנק" : "משימה חדשה בבנק") +
              " "
          ),
          _vm.isEdit
            ? _c("span", { staticClass: "task-id" }, [
                _vm._v(_vm._s(_vm.row.id)),
              ])
            : _vm._e(),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("h4", { staticClass: "section-container" }, [
            _vm._v("פרטי משימה"),
          ]),
          _c(
            "b-field",
            {
              attrs: {
                label: "שם המשימה *",
                type: _vm.submitted && !_vm.model.name ? "is-danger" : "",
                message: _vm.submitted && !_vm.model.name ? "שדה חובה" : "",
              },
            },
            [
              _c("b-input", {
                attrs: { placeholder: "לדוגמה: הגשת תרגיל 3 — דיני חוזים" },
                model: {
                  value: _vm.model.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "name", $$v)
                  },
                  expression: "model.name",
                },
              }),
            ],
            1
          ),
          _c("b-field", { attrs: { label: "תיאור" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.description,
                  expression: "model.description",
                },
              ],
              staticStyle: {
                border: "1px solid gray",
                width: "100%",
                padding: "14px",
              },
              attrs: { type: "text", name: "", id: "" },
              domProps: { value: _vm.model.description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "description", $event.target.value)
                },
              },
            }),
          ]),
          _c("h4", { staticClass: "section-container" }, [_vm._v("סיווג")]),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-field",
                {
                  attrs: {
                    label: "סוג משימה *",
                    type:
                      _vm.submitted && !_vm.model.taskTypeId ? "is-danger" : "",
                  },
                },
                [
                  _c(
                    "b-select",
                    {
                      attrs: { placeholder: "בחר סוג", expanded: "" },
                      on: { input: _vm.onTaskTypeChange },
                      model: {
                        value: _vm.model.taskTypeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "taskTypeId", $$v)
                        },
                        expression: "model.taskTypeId",
                      },
                    },
                    _vm._l(_vm.taskTypes, function (t) {
                      return _c(
                        "option",
                        { key: t.Value, domProps: { value: t.Value } },
                        [_vm._v(_vm._s(t.Text))]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _vm.subTypes.length
                ? _c(
                    "b-field",
                    { attrs: { label: "תת-סוג" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { placeholder: "בחר תת-סוג", expanded: "" },
                          model: {
                            value: _vm.model.subTypeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "subTypeId", $$v)
                            },
                            expression: "model.subTypeId",
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("— ללא —"),
                          ]),
                          _vm._l(_vm.subTypes, function (s) {
                            return _c(
                              "option",
                              { key: s.Value, domProps: { value: s.Value } },
                              [_vm._v(_vm._s(s.Text))]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-field",
                { attrs: { label: "נושא", expanded: "" } },
                [
                  _c("FieldInlineSelect", {
                    attrs: {
                      label: "נושא",
                      placeholder: "הקלד לחיפוש נושא",
                      clearable: true,
                      filterable: true,
                      options: [],
                      "fetch-options": _vm.onSearchSubjects,
                    },
                    on: { onChange: _vm.onSubjectChange },
                    model: {
                      value: _vm.subjectSelection,
                      callback: function ($$v) {
                        _vm.subjectSelection = $$v
                      },
                      expression: "subjectSelection",
                    },
                  }),
                ],
                1
              ),
              _c("b-field", { attrs: { label: "תגיות" } }, [
                _c(
                  "div",
                  { staticClass: "tags-readonly" },
                  [
                    _vm._l(_vm.tagsArray, function (t) {
                      return _c("b-tag", { key: t, attrs: { ellipsis: "" } }, [
                        _vm._v(_vm._s(t)),
                      ])
                    }),
                    !_vm.tagsArray.length
                      ? _c("span", { staticClass: "tags-empty" }, [
                          _vm._v("— ללא תגיות —"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
          _c("h4", { staticClass: "section-container" }, [_vm._v("הגדרות")]),
          _c(
            "b-field",
            { attrs: { label: "סטטוס" } },
            [
              _c(
                "b-switch",
                {
                  model: {
                    value: _vm.model.isActive,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "isActive", $$v)
                    },
                    expression: "model.isActive",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.model.isActive ? "פעיל" : "לא פעיל") + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-field",
                { attrs: { label: "משך (דקות)" } },
                [
                  _c("b-numberinput", {
                    attrs: { min: 0, "controls-position": "compact" },
                    model: {
                      value: _vm.model.durationMinutes,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "durationMinutes", $$v)
                      },
                      expression: "model.durationMinutes",
                    },
                  }),
                ],
                1
              ),
              _c("b-field", { attrs: { label: "עדיפות" } }, [
                _c(
                  "span",
                  {
                    staticClass: "value-readonly",
                    class: { "is-empty": !_vm.model.priority },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.model.priority || _vm.emptyText) + " "
                    ),
                  ]
                ),
              ]),
              _c("b-field", { attrs: { label: "חובה" } }, [
                _c(
                  "span",
                  {
                    staticClass: "value-readonly",
                    class: { "is-empty": !_vm.model.mustDo },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.model.mustDo || _vm.emptyText) + " "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("b-field", { attrs: { label: "שלב" } }, [
                _c(
                  "span",
                  {
                    staticClass: "value-readonly",
                    class: { "is-empty": _vm.isBlank(_vm.model.stage) },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.displayValue(_vm.model.stage)) + " "
                    ),
                  ]
                ),
              ]),
              _c("b-field", { attrs: { label: "יום בשלב" } }, [
                _c(
                  "span",
                  {
                    staticClass: "value-readonly",
                    class: { "is-empty": _vm.isBlank(_vm.model.stageDay) },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.displayValue(_vm.model.stageDay)) + " "
                    ),
                  ]
                ),
              ]),
              _c(
                "b-field",
                { attrs: { label: "מזהה חיצוני" } },
                [
                  _c("b-numberinput", {
                    attrs: { controls: false, placeholder: "ExternalId" },
                    model: {
                      value: _vm.model.externalId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "externalId", $$v)
                      },
                      expression: "model.externalId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { label: "הערות" } },
            [
              _c("b-input", {
                attrs: {
                  type: "textarea",
                  rows: "2",
                  placeholder: "הערות פנימיות",
                },
                model: {
                  value: _vm.model.taskComments,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "taskComments", $$v)
                  },
                  expression: "model.taskComments",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              type: "is-primary",
              label: "שמור",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "ביטול" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }